import React, {useState, useEffect, FunctionComponent} from 'react'

import {
	isValidMailAddress} from '../utils/util'

import { useTestPlacesQuery, GQLTestPlacesQuery, useCreateEntryMutation, GQLCreateEntryMutation, GQLTestType, useTestDatesQuery, GQLCouponCodeFragment} from '../generated/graphql'
import Cookies from 'js-cookie'
import { sexConverter, testTypeConverter, acquisitionFromConverter, kyofukuMemberTypeConverter, paymentMethodConverter, chueiBankMemberTypeConverter } from '../utils/enum-converter'
import {
	ApolloClient,
	InMemoryCache,
	HttpLink,
	ApolloProvider
} from '@apollo/client'
import { authLink } from '../auth-link'
import { TestArea } from '../constants/test-area'
import { ValueOf } from '../utils/type-utils'
import { SelectTestCourse, SelectChueiBankTestCourse, SelectRiebeTestCourse, SelectKyofukuTestCourse, SelectPromotionTestCourse, SelectSapporoChushoTestCourse, SelectBohseiTestCourse, SelectInsuranceTestCourse, SelectGenovisionTestCourse, SelectReloClubTestCourse, SelectBenefitTestCourse, SelectCouponCodeCourse, SelectGoldenLoopCourse } from '../components/select-test-course'
import { SelectTestType } from '../components/select-test-type'
import { SelectTestArea } from '../components/select-test-area'
import { InputKyofukuInformation, InputChueiBankInformation, InputRIEBEInformation, InputCSPInformation, InputMBClubMemberInformation, InputSapporoChushoInformation, InputBohseiInformation, InputInsuranceInformation, InputGenovisionInformation, InputCouponCodeInformation, InputGoldenLoopInformation } from '../components/input-information'
import { InputPersonalInformation } from '../components/input-personal-information'
import { Confirm } from '../components/confirm'
import { Complete } from '../components/complete'
import { useValidateState, has, isNull, isValidDate } from '../utils/entry-utils'
import { assertUnreachable } from '../utils/entry-utils'
import {TType, typeLabel, types} from '../../../api/src/enms/type'
import dayjs, { Dayjs } from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/ja'
import { styled } from 'styled-components'

import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
import { createRoot } from 'react-dom/client'
import { getVersion } from '../../../api/src/utils/get-version'
import { SelectTestType0 } from '../components/select-test-type0'
import { sendAnalyticsEvent } from '../utils/gtag'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)
dayjs.locale({
	name: 'ja',
	formats: {},
	relativeTime: {},
	weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
})

export type NavigateProps = {
	onNext: () => void,
	onPrev: () => void
}

export type TestPlacesProps = {
	testPlaces: GQLTestPlacesQuery['testPlaces']
}

export type TestPlaceProps = {
	testPlace: GQLTestPlacesQuery['testPlaces'][0]
}

enum Step {
	SelectTestType0,
	SelectTestType,
	InputPersonalInformation,
	InputKyofukuInformation,
	InputChueiBankInformation,
	InputRiebeInformation,
	InputPromotionInformation,
	InputMbClubMemberInformation,
	InputSapporoChushoInformation,
	InputBohseiInformation,
	InputGenovisionInformation,
	InputInsuranceInformation,
	InputCouponCodeInformation,
	InputGoldenLoopInformation,
	SelectTestArea,
	SelectTestCourse,
	SelectChueiBankTestCourse,
	SelectRiebeTestCourse,
	SelectPromotionTestCourse,
	SelectKyofukuTestCourse,
	SelectSapporoTestCourse,
	SelectBohseiTestCourse,
	SelectGenovisionTestCourse,
	SelectInsuranceTestCourse,
	SelectReloClubTestCourse,
	SelectBenefitTestCourse,
	SelectCouponCodeTestCourse,
	SelectGoldenLoopTestCourse,
	Confirm,
	Sending,
	Complete,
	Failed
}

const StepLabelMap: Record<Step, string> = {
	[Step.SelectTestType0]: 'select_test_type0',
	[Step.SelectTestType]: 'select_test_type',
	[Step.InputPersonalInformation]: 'input_personal_information',
	[Step.InputKyofukuInformation]: 'input_kyofuku_information',
	[Step.InputChueiBankInformation]: 'input_chuei_bank_information',
	[Step.InputRiebeInformation]: 'input_riebe_information',
	[Step.InputPromotionInformation]: 'input_promotion_information',
	[Step.InputMbClubMemberInformation]: 'input_mb_club_member_information',
	[Step.InputSapporoChushoInformation]: 'input_sapporo_chusho_information',
	[Step.InputBohseiInformation]: 'input_bohsei_information',
	[Step.InputGenovisionInformation]: 'input_genovision_information',
	[Step.InputInsuranceInformation]: 'input_insurance_information',
	[Step.InputCouponCodeInformation]: 'input_coupon_code_information',
	[Step.InputGoldenLoopInformation]: 'input_golden_loop_information',
	[Step.SelectTestArea]: 'select_test_area',
	[Step.SelectTestCourse]: 'select_test_course',
	[Step.SelectChueiBankTestCourse]: 'select_chuei_bank_test_course',
	[Step.SelectRiebeTestCourse]: 'select_riebe_test_course',
	[Step.SelectPromotionTestCourse]: 'select_promotion_test_course',
	[Step.SelectKyofukuTestCourse]: 'select_kyofuku_test_course',
	[Step.SelectSapporoTestCourse]: 'select_sapporo_test_course',
	[Step.SelectBohseiTestCourse]: 'select_bohsei_test_course',
	[Step.SelectGenovisionTestCourse]: 'select_genovision_test_course',
	[Step.SelectInsuranceTestCourse]: 'select_insurance_test_course',
	[Step.SelectReloClubTestCourse]: 'select_relo_club_test_course',
	[Step.SelectBenefitTestCourse]: 'select_benefit_test_course',
	[Step.SelectCouponCodeTestCourse]: 'select_coupon_code_test_course',
	[Step.SelectGoldenLoopTestCourse]: 'select_golden_loop_test_course',
	[Step.Confirm]: 'confirm',
	[Step.Sending]: 'sending',
	[Step.Complete]: 'complete',
	[Step.Failed]: 'failed',
}

export const OLD_TEST_TYPE = {
	MB_CLUB: 0,
	OTHER: 1,
	NEW_MB_CLUB: 2,
	KYOFUKU: 3,
	CHUEI_BANK: 4,
	RIEBE: 5,
	CSP: 6,
	SAPPORO_CHUSHO: 7,
	BOHSEI: 8,
	INSURANCE: 9,
	GENOVISION: 10,
	RELO_CLUB: 11,
	BENEFIT: 12,
	GOLDEN_LOOP: 13,
	COUPON: 14
} as const

export const OLD_TEST_TYPE_LABEL: Record<ValueOf<typeof OLD_TEST_TYPE>, string> = {
	[OLD_TEST_TYPE.MB_CLUB]: 'MBクラブ',
	[OLD_TEST_TYPE.OTHER]: '一般の方、㈱レナテックからハガキ・メールが届いた方',
	[OLD_TEST_TYPE.NEW_MB_CLUB]: 'スタンダードMB（継続研究参加コース）',
	[OLD_TEST_TYPE.KYOFUKU]: '神奈川県教育福祉振興会',
	[OLD_TEST_TYPE.CHUEI_BANK]: '中栄信用金庫',
	[OLD_TEST_TYPE.RIEBE]: 'RIEBE会員特別コース',
	[OLD_TEST_TYPE.CSP]: '各種イベントクーポンコードコース',
	[OLD_TEST_TYPE.SAPPORO_CHUSHO]: '公財 札幌市中小企業共済センター（さぽーとさっぽろ）会員の方',
	[OLD_TEST_TYPE.BOHSEI]: '株式会社望星薬局社員の方',
	[OLD_TEST_TYPE.INSURANCE]: '保険会社からご紹介を受けた方',
	[OLD_TEST_TYPE.GENOVISION]: 'Genovision®会員の方',
	[OLD_TEST_TYPE.RELO_CLUB]: '福利厚生俱楽部・クラブオフアライアンスの会員の方',
	[OLD_TEST_TYPE.BENEFIT]: 'ベネフィット',
	[OLD_TEST_TYPE.GOLDEN_LOOP]: 'ゴールデンループ読者、およびご紹介の方',
	[OLD_TEST_TYPE.COUPON]: 'クーポンコードをお持ちの方'
}

type DateRange = [Dayjs | null, Dayjs | null]
export const AVAILABLE_RANGE: Record<ValueOf<typeof OLD_TEST_TYPE>, DateRange | undefined> = {
	[OLD_TEST_TYPE.MB_CLUB]: [null, null],
	[OLD_TEST_TYPE.OTHER]: [null, null],
	[OLD_TEST_TYPE.NEW_MB_CLUB]: [null, null],
	[OLD_TEST_TYPE.KYOFUKU]: [null, dayjs.tz('2026-04-01', 'Asia/Tokyo')],
	[OLD_TEST_TYPE.CHUEI_BANK]: [null, null],
	[OLD_TEST_TYPE.RIEBE]: [null, null],
	[OLD_TEST_TYPE.CSP]: [null, null],
	[OLD_TEST_TYPE.SAPPORO_CHUSHO]: [null, dayjs.tz('2026-04-01', 'Asia/Tokyo')],
	[OLD_TEST_TYPE.BOHSEI]: [null, dayjs.tz('2026-04-01', 'Asia/Tokyo')],
	[OLD_TEST_TYPE.INSURANCE]: [null, null],
	[OLD_TEST_TYPE.GENOVISION]: [null, null],
	[OLD_TEST_TYPE.RELO_CLUB]: [null, null],
	[OLD_TEST_TYPE.BENEFIT]: [null, null],
	[OLD_TEST_TYPE.GOLDEN_LOOP]: [null, null],
	[OLD_TEST_TYPE.COUPON]: [null, null],
}

const OLD_TEST_COURSE = {
	TRYAL: 0,
	TRYAL_WITH_COHORT: 3,
	STANDARD: 1,
	MB_CLUB: 2,
	STANDARD_FREE: 4,
	STANDARD_FREE_LP: 5,
} as const

export const OLD_TEST_COURSE_LABEL: Record<ValueOf<typeof OLD_TEST_COURSE>, string> = {
	[OLD_TEST_COURSE.TRYAL]: '(旧)トライアルMB',
	[OLD_TEST_COURSE.TRYAL_WITH_COHORT]: 'トライアルMB',
	[OLD_TEST_COURSE.STANDARD]: '(旧)スタンダードMB',
	[OLD_TEST_COURSE.MB_CLUB]: 'スタンダードMB（継続研究参加コース）',
	[OLD_TEST_COURSE.STANDARD_FREE]: 'スタンダードフリー（一般検査コース）',
	[OLD_TEST_COURSE.STANDARD_FREE_LP]: 'スタンダードフリー（一般検査コース）'
}

const PAYMENT_METHOD = {
	DEBIT: 0,
	CREDIT: 1
} as const

export const KYOFUKU_MEMBER_TYPE = {
	CURRENT: 0,
	CONTINUATION: 1,
	COMPANION: 2,
	CURRENT2: 3
} as const

export const KYOFUKU_MEMBER_TYPE_LABEL: Record<ValueOf<typeof KYOFUKU_MEMBER_TYPE>, string> = {
	[KYOFUKU_MEMBER_TYPE.CURRENT]: '現職会員',
	[KYOFUKU_MEMBER_TYPE.CONTINUATION]: '継続会員',
	[KYOFUKU_MEMBER_TYPE.COMPANION]: '会員同行者',
	[KYOFUKU_MEMBER_TYPE.CURRENT2]: '現職会員61歳以上'
}

export const CHUEI_BANK_MEMBER_TYPE = {
	NENKIN_MEMBER: 0,
	SYOKUIKI_MEMBER: 1
} as const

export const CHUEI_BANK_MEMBER_TYPE_LABEL: Record<ValueOf<typeof CHUEI_BANK_MEMBER_TYPE>, string> = {
	[CHUEI_BANK_MEMBER_TYPE.NENKIN_MEMBER]: '「ねんきん友の会」会員',
	[CHUEI_BANK_MEMBER_TYPE.SYOKUIKI_MEMBER]: '「職域サポート」会員'
}

export const SEX = {
	MALE: 0,
	FEMALE: 1
} as const

export const SEX_LABEL: Record<ValueOf<typeof SEX>, string> = {
	[SEX.MALE]: '男',
	[SEX.FEMALE]: '女'
}

export const HOW_DID_YOU_KNOW = {
	INTRODUCE: 1,
	WEB_AD: 2,
	OTHER_AD: 0,
	MEDIA: 3,
	PAPER_AD: 4,
	WEB_SITE: 5,
	RADIO_OR_TV_OR_YOUTUBE: 6,
	WEB_SEARCH: 7,
	OTHER: 8,
	HOSPITAL_OR_CLINIC: 9,
	EMAIL_FROM_RENATECH: 11,
	MAIL_FROM_RENATECH: 10
} as const

export const HOW_DID_YOU_KNOW_LABEL: Record<ValueOf<typeof HOW_DID_YOU_KNOW>, string> = {
	[HOW_DID_YOU_KNOW.INTRODUCE]: '知人などの紹介',
	[HOW_DID_YOU_KNOW.WEB_AD]: 'Web広告（Googleなど）',
	[HOW_DID_YOU_KNOW.OTHER_AD]: '雑誌、フリーペーパー、新聞などの広告',
	[HOW_DID_YOU_KNOW.MEDIA]: 'ラジオやテレビ、youtube',
	[HOW_DID_YOU_KNOW.PAPER_AD]: '新聞、フリーペーパーなど紙広告',
	[HOW_DID_YOU_KNOW.WEB_SITE]: 'ブログや情報系のWEBサイト',
	[HOW_DID_YOU_KNOW.RADIO_OR_TV_OR_YOUTUBE]: 'ラジオやテレビ、YouTube',
	[HOW_DID_YOU_KNOW.WEB_SEARCH]: 'Google検索で初めて知った',
	[HOW_DID_YOU_KNOW.OTHER]: 'その他',
	[HOW_DID_YOU_KNOW.HOSPITAL_OR_CLINIC]: '病院・クリニックからのハガキ等',
	[HOW_DID_YOU_KNOW.MAIL_FROM_RENATECH]: 'レナテックからのハガキ・封書',
	[HOW_DID_YOU_KNOW.EMAIL_FROM_RENATECH]: 'レナテックからの電子メール',
}

export const testType0 = ['common', 'other'] as const
export type TEST_TYPE0 = typeof testType0[number]

document.addEventListener('DOMContentLoaded', () => {
	const client = new ApolloClient({
		cache: new InMemoryCache(),
		link: authLink.concat(new HttpLink({
			uri: document.getElementById('api-endpoint')?.dataset.apiEndpoint!,
			credentials: 'same-origin'
		}))
	})

	createRoot(document.getElementById('container')!).render(<div id="entry">
		<ApolloProvider client={client}>
			<Entry />
		</ApolloProvider>
	</div>)
})

const SelectedItems = styled.div`
	font-size: 1rem;
	line-height: 1.5;
	color: #1c48a7;
`

const Entry: FunctionComponent = () => {
	const [step, setStep] = useState(Step.SelectTestType0)

	const [urlString, setUrlString] = useState(Cookies.get('ptag'))
	const [tTag, setTTag] = useState(Cookies.get('ttag'))

	// fetched data
	const [addresses, setAddresses] = useState([])
	const [postRes, setPostRes] = useState<GQLCreateEntryMutation['createEntry'] | null>(null)
	const isValidServiceCodeState = useState<boolean>(false)


	const testAreaState = useValidateState<TestArea | null>(null, v => v !== null)

	const testType0State = useValidateState<TEST_TYPE0 | null>(null, v => testType0.some(type => type === v))

	// type and course
	const testTypeState = useValidateState<ValueOf<typeof OLD_TEST_TYPE> | null>(null, v => has(OLD_TEST_TYPE, v))
	const testCourseState = useValidateState<number | null>(null, v => typeof v === 'number')
	const typeState = useValidateState<string | null>(null, v => types.includes(v as TType))
	const versionState = useValidateState<number | null>(2, v => typeof v === 'number')

	// location and date
	const testLocationState = useValidateState<string | null>(null, v => v !== null)
	const testDateState = useValidateState<string | null>(null, v => v !== null)

	// kyofuku informations
	const kyofukuMemberTypeState = useValidateState<number | null>(null, v => has(KYOFUKU_MEMBER_TYPE, v))
	const kyofukuMemberIdState = useValidateState('', v => v.length > 0 && v.length < 20)
	const kyofukuMemberNameState = useValidateState('', () => true)

	// Chuei bank member type
	const chueiBankMemberTypeState = useValidateState<number | null>(null, v => has(CHUEI_BANK_MEMBER_TYPE, v))

	// RIEBE union name
	const riebeUnionNameState = useValidateState('', v => v.length > 0 && v.length < 128)

	// Some event promotion code
	const cspPromotionCodeState = useValidateState('', v => /^[a-zA-Z0-9]{6,6}$/.test(v))

	// sapporo chusho informations
	const sapporoChushoMemberIdState = useValidateState('', v => /^\d{6}-\d{8}$/.test(v))
	const sapporoChushoMemberNameState = useValidateState('', v => v.length > 0)

	// genovision
	const genovisionTypeState = useValidateState('', v => /^[0-9]{1,}$/.test(v))
	const genovisionCodeState = useValidateState('', v => /^[0-9]{1,}$/.test(v))

	// sign up MB Club informations
	const mbClubMembershipAgreementState = useValidateState(false, v => v)
	const mbClubPaymentMethodState = useValidateState<number | null>(null, v => has(PAYMENT_METHOD, v))

	// current MB Club informations
	const mbClubMemberIdState = useValidateState('', v => v.length < 8)
	const lastTestLocationState = useValidateState<string | null>(null, v => v !== null)
	const lastTestDateState = useValidateState<Date | null>(null, v => isValidDate(v))

	const antiCovid19TestState = useValidateState<boolean | null>(null, v => typeof v === 'boolean')

	// personal Information
	const zipcodeState = useValidateState('', v => v.length === 7 && /^\d{7}$/.test(v) && addresses.length > 0)
	const address1State = useValidateState('', v => typeof v === 'string' && v.length > 0)
	const address2State = useValidateState('', v => v.length > 0)
	const phoneNumberState = useValidateState('', v => /^[0-9]{10,11}$/.test(v))
	const mailAddressState = useValidateState('', v => isValidMailAddress(v))
	const confirmMailAddressState = useValidateState('', v => v === mailAddressState[0])
	const firstNameState = useValidateState('', v => v.length > 0)
	const firstNameKanaState = useValidateState('', v => v.length > 0 && /^[ァ-ヺーヽヾ゛゜]+$/.test(v))
	const lastNameState = useValidateState('', v => v.length > 0)
	const lastNameKanaState = useValidateState('', v => v.length > 0 && /^[ァ-ヺーヽヾ゛゜]+$/.test(v))
	const sexState = useValidateState<number | null>(null, v => has(SEX, v)) // 0: male, 1: femele
	const birthdayState = useValidateState<Date | null>(null, v => isValidDate(v))
	const birthYearState = useValidateState('', v => /\d{4}/.test(v))
	const birthMonthState = useValidateState('', v => Number(v) > 0 && Number(v) < 13)
	const birthDateState = useValidateState('', v => Number(v) > 0 && Number(v) < 32)
	const introducerIdState = useValidateState('', () => true)
	const hasEntryBeforeState = useValidateState<boolean | null>(null, v => typeof v === 'boolean')

	// Questionnaire
	const howDidYouKnowState = useValidateState<number | null>(null, v => v !== null || testTypeState[0] === OLD_TEST_TYPE.CHUEI_BANK || testTypeState[0] === OLD_TEST_TYPE.GOLDEN_LOOP)
	const howDidYouKnowAdMediaState = useValidateState('', v => [HOW_DID_YOU_KNOW.OTHER, HOW_DID_YOU_KNOW.PAPER_AD, HOW_DID_YOU_KNOW.WEB_SITE].includes(howDidYouKnowState[0] as any) ? (v.length > (hasEntryBeforeState[0] ? -1 : 0) && v.length < 61) : true)

	// Message
	const messageState = useValidateState('', () => true)

	// Coupon
	const couponCodeState = useValidateState<GQLCouponCodeFragment | null>(null, () => true)

	// Golden loop
	const goldenLoopTypeState = useValidateState(null, v => Number.isInteger(v))

	const testPlacesQuery = useTestPlacesQuery({})
	const testPlaces = testPlacesQuery.data?.testPlaces

	const testDatesQuery = useTestDatesQuery({
		skip: testLocationState[0] === null,
		variables: {
			testPlaceId: testLocationState[0]
		}
	})
	const testDates = testDatesQuery.data?.testDates

	// set birthday from user input data
	useEffect(() => {
		const [birthYear] = birthYearState
		const [birthMonth] = birthMonthState
		const [birthDate] = birthDateState
		const [, setBirthday] = birthdayState

		const y = Number(birthYear)
		const m = Number(birthMonth) -1
		const d = Number(birthDate)

		const date = new Date(1900, 0, 1)

		date.setFullYear(y)
		date.setMonth(m)
		date.setDate(d)

		if(isValidDate(date) && date.getFullYear() === y && date.getMonth() === m && date.getDate() === d && date.getFullYear() > 1900){
			setBirthday(date)
		} else {
			setBirthday(new Date(NaN))
		}
	}, [birthYearState[0], birthMonthState[0], birthDateState[0]])

	// set address1 from zipcode
	useEffect(() => {
		const [zipcode] = zipcodeState
		const [, setAddress1] = address1State
		if(/\d{7}/.test(zipcode)){
			fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`, {mode: 'cors'}).then(res => {
				if(res.status !== 200){
					throw new Error()
				}
				return res.json()
			}).then(res => {
				if(res.status !== 200){
					if(res.status !== 200){
						throw new Error()
					}
				}
				if(zipcodeState[0] === zipcode){
					const data = res.results.map(a => `${a.address1}${a.address2}${a.address3}`)
					setAddresses(data)
					if(data.length > 0){
						const [, setAddress1] = address1State
						setAddress1(data[0])
					}
				}
			}, () => {
				if(zipcodeState[0] === zipcode){
					setAddresses([])
					setAddress1('')
				}
			})
		} else {
			if(zipcodeState[0] === zipcode){
				setAddresses([])
				setAddress1('')
			}
		}
	}, [zipcodeState[0]])

	useEffect(() => {
		sendAnalyticsEvent(`form_step_${StepLabelMap[step]}`, {});
	}, [step]);

	useEffect(() => {
		if (step === Step.Complete) return;
		const handler = () => {
			sendAnalyticsEvent('form_abandon', {
				step: StepLabelMap[step],
			});
		};
		window.addEventListener('beforeunload', handler);
		return () => window.removeEventListener('beforeunload', handler);
	}, [step]);

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [step])
	
	useEffect(() => {
		if(urlString){
			testTypeState[1](OLD_TEST_TYPE.OTHER)
			testCourseState[1](OLD_TEST_COURSE.STANDARD_FREE)
		}
	}, [])

	useEffect(() => {
		if(testPlaces){
			if(urlString && !testPlaces.find(tp => tp.urlString === urlString)){
				setUrlString(undefined)
			}
		}
	}, [testPlaces])

	useEffect(() => {
		if(testType0State[0]){
			next()
		}
	}, [testType0State[0]])


	const [createEntryMutation] = useCreateEntryMutation()

	async function send(){
		try {
			const [testType] = testTypeState
			const [testCourse] = testCourseState
			const [type] = typeState

			// location and date
			const [] = testLocationState
			const [] = testDateState

			// kyofuku informations
			const [kyofukuMemberType] = kyofukuMemberTypeState
			const [kyofukuMemberId] = kyofukuMemberIdState
			const [kyofukuMemberName] = kyofukuMemberNameState

			// Chuei bank member type
			const [chueiBankMemberType] = chueiBankMemberTypeState

			// RIEBE 
			const [riebeUnionName] = riebeUnionNameState

			// CSP
			const [cspPromotionCode] = cspPromotionCodeState

			// sapporo chusho informations
			const [sapporoChushoMemberId] = sapporoChushoMemberIdState
			const [sapporoChushoMemberName] = sapporoChushoMemberNameState

			// genovision
			const [genovisionType] = genovisionTypeState
			const [genovisionCode] = genovisionCodeState

			// sign up MB Club informations
			const [mbClubPaymentMethod] = mbClubPaymentMethodState

			// current MB Club informations
			const [mbClubMemberId] = mbClubMemberIdState
			const [lastTestLocation] = lastTestLocationState
			const [lastTestDate] = lastTestDateState

			const [antiCovid19Test] = antiCovid19TestState

			// personal Information
			const [zipcode] = zipcodeState
			const [address1] = address1State
			const [address2] = address2State
			const [phoneNumber] = phoneNumberState
			const [mailAddress] = mailAddressState
			const [firstName] = firstNameState
			const [firstNameKana] = firstNameKanaState
			const [lastName] = lastNameState
			const [lastNameKana] = lastNameKanaState
			const [birthday] = birthdayState
			const [sex] = sexState
			const [introducerId] = introducerIdState
			const [testDateId] = testDateState

			// Questionnaire
			const [howDidYouKnow] = howDidYouKnowState
			const [howDidYouKnowAdMedia] = howDidYouKnowAdMediaState

			// Message
			const [message] = messageState

			// Code
			const [hasEntryBefore] = hasEntryBeforeState

			// Coupon
			const [couponCode] = couponCodeState

			// Golden loop
			const [goldenLoopType] = goldenLoopTypeState

			if(!type) {
				alert('エラーが発生いたしました。')
				return
			}

			const createEntryMutationResult = await createEntryMutation({
				variables: {
					input: {
						firstName,
						lastName,
						firstNameKana,
						lastNameKana,
						sex: sexConverter(sex!),
						birthday: birthday!.toISOString(),
						zipcode,
						address1,
						address2,
						phoneNumber,
						email: mailAddress,
						testType: testTypeConverter(testType!, testCourse!),
						introducerId,
						affiliateTag: Cookies.get('tag') ?? null,
						placeTag: urlString,
						acquisitionFrom: acquisitionFromConverter(howDidYouKnow!),
						acquisitionFromAdMedia: howDidYouKnowAdMedia,
						message,
						hasEntryBefore: hasEntryBefore as boolean, // FIXME
						testDateId: testDateId!,
						kyofukuMemberType: kyofukuMemberTypeConverter(kyofukuMemberType!),
						kyofukuMemberId,
						kyofukuMemberName,
						mbClubPaymentMethod: paymentMethodConverter(mbClubPaymentMethod!),
						mbClubMemberId,
						lastTestPlaceId: lastTestLocation!,
						lastTestDate: lastTestDate ? lastTestDate.toISOString() : null,
						promotionCode: cspPromotionCode,
						riebeUnionName,
						sapporoChushoMemberId,
						sapporoChushoMemberName,
						genovisionType: Number(genovisionType),
						genovisionCode,
						chueiBankMemberType: chueiBankMemberTypeConverter(chueiBankMemberType!),
						antiCovid19Test: antiCovid19Test ?? false,
						type: type,
						couponCode: couponCode?.code,
						goldenLoopType
					}
				}
			})

			const res = createEntryMutationResult.data?.createEntry
			if(!res) throw new Error('Entry failed')

			if(process.env.APP_ENV === 'production'){
				gtag('event', 'conversion', {'send_to': 'AW-694581692/pcqtCIe96bQBELzzmcsC'})
				gtag('config', 'UA-141581491-1', {page_path: '/entry-complete'})

				try{
					const version = '1.0.0';
					const sp = document.createElement('script');
					sp.type = 'text/javascript';
					sp.async = true;
					sp.src = 'https://willap.jp/conversion.js?cKey=lZQt-BVsSReTuqwLXFF4xA&version=' + version;
					const s = document.getElementsByTagName('script')[0];
					s?.parentNode?.insertBefore(sp, s);
				} catch(err) {
					console.error(err)
				}
			}

			return res
		} catch(err) {
			// 送信失敗イベント
			sendAnalyticsEvent('form_submit_failed', {})

			console.error(err)
			if(err instanceof Error && err.message === 'Test date is unavailable'){
				await testPlacesQuery.refetch()
				alert('大変申し訳ございません。\nご希望の検査日は定員に達しました。\nお手数ですが他の検査日をお選びください。')
				testDateState[1](null)
				setStep(Step.SelectTestArea)
				return
			}
			setStep(Step.Failed)
		}
	}
	async function next(){

		const [testType] = testTypeState
		const [, setTestCourse] = testCourseState
		switch(step){
			case Step.SelectTestType0:
				switch(testType0State[0]){
					case 'common':
						testTypeState[1](OLD_TEST_TYPE.OTHER)
						setStep(Step.SelectTestArea)
						break
					case 'other':
						setStep(Step.SelectTestType)
						break
				}
				break
			case Step.SelectTestType:
				switch(testType){
					case OLD_TEST_TYPE.OTHER: // Other
						setStep(Step.SelectTestArea)
						break
					case OLD_TEST_TYPE.KYOFUKU: // Kyofuku member
						setStep(Step.InputKyofukuInformation)
						break
					case OLD_TEST_TYPE.CHUEI_BANK:
						setStep(Step.InputChueiBankInformation)
						break
					case OLD_TEST_TYPE.RIEBE:
						setStep(Step.InputRiebeInformation)
						break
					case OLD_TEST_TYPE.CSP:
						setStep(Step.InputPromotionInformation)
						break
					case OLD_TEST_TYPE.SAPPORO_CHUSHO:
						setStep(Step.InputSapporoChushoInformation)
						break
					case OLD_TEST_TYPE.BOHSEI:
						setStep(Step.InputBohseiInformation)
						break
					case OLD_TEST_TYPE.GENOVISION:
						setStep(Step.InputGenovisionInformation)
						break
					case OLD_TEST_TYPE.INSURANCE:
						setStep(Step.InputInsuranceInformation)
						break
					case OLD_TEST_TYPE.RELO_CLUB:
						setStep(Step.SelectTestArea)
						break
					case OLD_TEST_TYPE.BENEFIT:
						setStep(Step.SelectTestArea)
						break
					case OLD_TEST_TYPE.COUPON:
						setStep(Step.InputCouponCodeInformation)
						break
					case OLD_TEST_TYPE.GOLDEN_LOOP:
						setStep(Step.InputGoldenLoopInformation)
						break
				}
				break
			case Step.InputChueiBankInformation:
			case Step.InputRiebeInformation:
			case Step.InputPromotionInformation:
			case Step.InputKyofukuInformation:
			case Step.InputMbClubMemberInformation:
			case Step.InputSapporoChushoInformation:
			case Step.InputBohseiInformation:
			case Step.InputGenovisionInformation:
			case Step.InputInsuranceInformation:
			case Step.InputCouponCodeInformation:
			case Step.InputGoldenLoopInformation:
				setStep(Step.SelectTestArea)
				break
			case Step.SelectTestArea:
				switch(testType){
					case OLD_TEST_TYPE.OTHER:
						setStep(Step.SelectTestCourse)
						break
					case OLD_TEST_TYPE.KYOFUKU:
						setStep(Step.SelectKyofukuTestCourse)
						break
					case OLD_TEST_TYPE.CHUEI_BANK:
						setStep(Step.SelectChueiBankTestCourse)
						break
					case OLD_TEST_TYPE.RIEBE:
						setStep(Step.SelectRiebeTestCourse)
						break
					case OLD_TEST_TYPE.CSP:
						setStep(Step.SelectPromotionTestCourse)
						break
					case OLD_TEST_TYPE.SAPPORO_CHUSHO:
						setStep(Step.SelectSapporoTestCourse)
						break
					case OLD_TEST_TYPE.BOHSEI:
						setStep(Step.SelectBohseiTestCourse)
						break
					case OLD_TEST_TYPE.GENOVISION:
						setStep(Step.SelectGenovisionTestCourse)
						break
					case OLD_TEST_TYPE.INSURANCE:
						setStep(Step.SelectInsuranceTestCourse)
						break
					case OLD_TEST_TYPE.RELO_CLUB:
						setStep(Step.SelectReloClubTestCourse)
						break
					case OLD_TEST_TYPE.BENEFIT:
						setStep(Step.SelectBenefitTestCourse)
						break
					case OLD_TEST_TYPE.COUPON:
						setStep(Step.SelectCouponCodeTestCourse)
						break
					case OLD_TEST_TYPE.GOLDEN_LOOP:
						setStep(Step.SelectGoldenLoopTestCourse)
						break
				}
				break
			case Step.SelectTestCourse:
			case Step.SelectKyofukuTestCourse:
			case Step.SelectChueiBankTestCourse:
			case Step.SelectRiebeTestCourse:
			case Step.SelectPromotionTestCourse:
			case Step.SelectSapporoTestCourse:
			case Step.SelectBohseiTestCourse:
			case Step.SelectGenovisionTestCourse:
			case Step.SelectReloClubTestCourse:
			case Step.SelectBenefitTestCourse:
			case Step.SelectInsuranceTestCourse:
			case Step.SelectCouponCodeTestCourse:
			case Step.SelectGoldenLoopTestCourse:
				setStep(Step.InputPersonalInformation)
				break
			case Step.InputPersonalInformation:
				setStep(Step.Confirm)
				break
			case Step.Confirm:
				setStep(Step.Sending)
				let res
				let err
				try {
					res = await send()
				} catch(e) {
					err = e
				}
				if(res.errors || err){
					console.error(err)
					console.log(res)
					setStep(Step.Failed)
				} else {
					setPostRes(res)
					setStep(Step.Complete)
				}
				break
		}
	}
	async function prev(){

		const [testType] = testTypeState
		const [] = testCourseState
		switch(step){
			case Step.SelectTestType:
				testType0State[1](null)
				testTypeState[1](null)
				setStep(Step.SelectTestType0)
				break
			case Step.InputChueiBankInformation:
			case Step.InputRiebeInformation:
			case Step.InputPromotionInformation:
			case Step.InputKyofukuInformation:
			case Step.InputMbClubMemberInformation:
			case Step.InputSapporoChushoInformation:
			case Step.InputBohseiInformation:
			case Step.InputGenovisionInformation:
			case Step.InputInsuranceInformation:
			case Step.SelectReloClubTestCourse:
			case Step.SelectBenefitTestCourse:
			case Step.InputCouponCodeInformation:
			case Step.InputGoldenLoopInformation:
				setStep(Step.SelectTestType)
				couponCodeState[1](null)
				kyofukuMemberIdState[1]('')
				kyofukuMemberNameState[1]('')
				kyofukuMemberTypeState[1](null)
				break
			case Step.SelectTestArea:
				testAreaState[1](null)
				testLocationState[1](null)
				testDateState[1](null)
				switch(testType0State[0]){
					case 'common':
						testType0State[1](null)
						testTypeState[1](null)
						setStep(Step.SelectTestType0)
						break
					case 'other':
						switch(testType){
							case OLD_TEST_TYPE.CHUEI_BANK:
								setStep(Step.InputChueiBankInformation)
								break
							case OLD_TEST_TYPE.RIEBE:
								setStep(Step.InputRiebeInformation)
								break
							case OLD_TEST_TYPE.CSP:
								setStep(Step.InputPromotionInformation)
								break
							case OLD_TEST_TYPE.KYOFUKU:
								setStep(Step.InputKyofukuInformation)
								break
							case OLD_TEST_TYPE.MB_CLUB:
								setStep(Step.InputMbClubMemberInformation)
								break
							case OLD_TEST_TYPE.SAPPORO_CHUSHO:
								setStep(Step.InputSapporoChushoInformation)
								break
							case OLD_TEST_TYPE.BOHSEI:
								setStep(Step.InputBohseiInformation)
								break
							case OLD_TEST_TYPE.GENOVISION:
								setStep(Step.InputGenovisionInformation)
								break
							case OLD_TEST_TYPE.INSURANCE:
								setStep(Step.InputInsuranceInformation)
								break
							case OLD_TEST_TYPE.COUPON:
								setStep(Step.InputCouponCodeInformation)
								break
							case OLD_TEST_TYPE.GOLDEN_LOOP:
								setStep(Step.InputGoldenLoopInformation)
								break
							default:
								setStep(Step.SelectTestType)
								break
						}
						break
				}
				break

			case Step.SelectTestCourse:
			case Step.SelectKyofukuTestCourse:
			case Step.SelectChueiBankTestCourse:
			case Step.SelectRiebeTestCourse:
			case Step.SelectPromotionTestCourse:
			case Step.SelectSapporoTestCourse:
			case Step.SelectBohseiTestCourse:
			case Step.SelectGenovisionTestCourse:
			case Step.SelectInsuranceTestCourse:
			case Step.SelectReloClubTestCourse:
			case Step.SelectBenefitTestCourse:
			case Step.SelectCouponCodeTestCourse:
			case Step.SelectGoldenLoopTestCourse:
				testCourseState[1](null)
				antiCovid19TestState[1](null)
				typeState[1](null)
				setStep(Step.SelectTestArea)
				break
			case Step.InputPersonalInformation:
				switch(testType){
					case OLD_TEST_TYPE.OTHER:
						setStep(Step.SelectTestCourse)
						break
					case OLD_TEST_TYPE.KYOFUKU:
						setStep(Step.SelectKyofukuTestCourse)
						break
					case OLD_TEST_TYPE.CHUEI_BANK:
						setStep(Step.SelectChueiBankTestCourse)
						break
					case OLD_TEST_TYPE.RIEBE:
						setStep(Step.SelectRiebeTestCourse)
						break
					case OLD_TEST_TYPE.CSP:
						setStep(Step.SelectPromotionTestCourse)
						break
					case OLD_TEST_TYPE.SAPPORO_CHUSHO:
						setStep(Step.SelectSapporoTestCourse)
						break
					case OLD_TEST_TYPE.BOHSEI:
						setStep(Step.SelectBohseiTestCourse)
						break
					case OLD_TEST_TYPE.GENOVISION:
						setStep(Step.SelectGenovisionTestCourse)
						break
					case OLD_TEST_TYPE.INSURANCE:
						setStep(Step.SelectInsuranceTestCourse)
						break
					case OLD_TEST_TYPE.RELO_CLUB:
						setStep(Step.SelectReloClubTestCourse)
						break
					case OLD_TEST_TYPE.BENEFIT:
						setStep(Step.SelectBenefitTestCourse)
						break
					case OLD_TEST_TYPE.COUPON:
						setStep(Step.SelectCouponCodeTestCourse)
						break
					case OLD_TEST_TYPE.GOLDEN_LOOP:
						setStep(Step.SelectGoldenLoopTestCourse)
						break
				}
				break

			case Step.Confirm:
				setStep(Step.InputPersonalInformation)
				break
		}
	}

	const testType = testTypeState[0]
	const testCourse = testCourseState[0]
	const getStepContent = () => {
		switch(step){
			case Step.SelectTestType0:
				return <SelectTestType0 onNext={next} testType0State={testType0State} />

			case Step.SelectTestType:
				return <SelectTestType onNext={next} onPrev={prev} testTypeState={testTypeState} standardFreeOnly={!!urlString} versionState={versionState} tTag={tTag}/>

			case Step.InputKyofukuInformation:
				return <InputKyofukuInformation onNext={next} onPrev={prev} kyofukuMemberTypeState={kyofukuMemberTypeState} kyofukuMemberIdState={kyofukuMemberIdState} kyofukuMemberNameState={kyofukuMemberNameState} />

			case Step.InputChueiBankInformation:
				return <InputChueiBankInformation onNext={next} onPrev={prev} chueiBankMemberTypeState={chueiBankMemberTypeState} />

			case Step.InputRiebeInformation:
				return <InputRIEBEInformation onNext={next} onPrev={prev} riebeUnionNameState={riebeUnionNameState} />

			case Step.InputPromotionInformation:
				return !testPlaces ? <Loading /> : <InputCSPInformation onNext={next} onPrev={prev} cspPromotionCodeState={cspPromotionCodeState} testPlaces={testPlaces} />
			
			case Step.InputMbClubMemberInformation:
				return !testPlaces ? <Loading /> : <InputMBClubMemberInformation onNext={next} onPrev={prev} mbClubMemberIdState={mbClubMemberIdState} lastTestLocationState={lastTestLocationState} lastTestDateState={lastTestDateState} testPlaces={testPlaces}/>
			
			case Step.InputSapporoChushoInformation:
				return <InputSapporoChushoInformation onNext={next} onPrev={prev} sapporoChushoMemberIdState={sapporoChushoMemberIdState} sapporoChushoMemberNameState={sapporoChushoMemberNameState} />

			case Step.InputBohseiInformation:
				return <InputBohseiInformation onNext={next} onPrev={prev} />
			
			case Step.InputGenovisionInformation:
				return <InputGenovisionInformation onNext={next} onPrev={prev} genovisionTypeState={genovisionTypeState}  />

			case Step.InputInsuranceInformation:
				return <InputInsuranceInformation onNext={next} onPrev={prev}/>
				
			case Step.InputCouponCodeInformation:
				return <InputCouponCodeInformation onNext={next} onPrev={prev} couponCodeState={couponCodeState}/>

			case Step.InputGoldenLoopInformation:
				return <InputGoldenLoopInformation onNext={next} onPrev={prev} goldenLoopTypeState={goldenLoopTypeState}/>

			case Step.SelectTestArea:
				return !testPlaces ? <Loading /> : <SelectTestArea
					onNext={next}
					onPrev={prev}
					testType={testType}
					testAreaState={testAreaState}
					testDateState={testDateState}
					testLocationState={testLocationState}
					couponCode={couponCodeState[0]}
					testPlaces={couponCodeState[0] ? couponCodeState[0].testPlaces : testPlaces
						.filter(p => !p.disabled)
						.filter(p => (testType === OLD_TEST_TYPE.OTHER && testCourse === OLD_TEST_COURSE.STANDARD_FREE) ? (p.acceptStandardFree || p.acceptStandardFreeLP || p.acceptStandardMb) : true)
						.filter(p => testType === OLD_TEST_TYPE.NEW_MB_CLUB ? p.acceptStandardMb : true)
						.filter(p => testType === OLD_TEST_TYPE.MB_CLUB ? p.acceptMbClub : true)
						.filter(p => testType === OLD_TEST_TYPE.KYOFUKU ? p.acceptKyofuku : true)
						.filter(p => testType === OLD_TEST_TYPE.CHUEI_BANK ? p.acceptChueiBank : true)
						.filter(p => testType === OLD_TEST_TYPE.RIEBE ? p.acceptRiebe : true)
						.filter(p => testType === OLD_TEST_TYPE.CSP ? p.acceptPromotion : true)
						.filter(p => testType === OLD_TEST_TYPE.SAPPORO_CHUSHO ? p.acceptSapporoChusho : true)
						.filter(p => testType === OLD_TEST_TYPE.BOHSEI ? (p.acceptBohseiMb || p.acceptBohseiFree) : true)
						.filter(p => testType === OLD_TEST_TYPE.GENOVISION ? p.acceptGenovision : true)
						.filter(p => testType === OLD_TEST_TYPE.INSURANCE ? p.acceptInsurance : true)
						.filter(p => testType === OLD_TEST_TYPE.RELO_CLUB ? p.acceptReloClub : true)
						.filter(p => testType === OLD_TEST_TYPE.BENEFIT ? p.acceptBenefit : true)
						.filter(p => testType === OLD_TEST_TYPE.GOLDEN_LOOP ? p.acceptGoldenLoop : true)
						.filter(p => {
							if(urlString){
								return p.urlString === urlString
							} else {
								return true
							}
						})
						.map(p => ({...p, disabled: p.disabled }))
					}
					testDates={testDates}
					version={versionState[0]!}
				/>

			case Step.SelectTestCourse:
				return !testPlaces ? <Loading /> : <SelectTestCourse
					onPrev={prev}
					onNext={next}
					testCourseState={testCourseState} 
					antiCovid19TestState={antiCovid19TestState}
					testPlace={testPlaces.find(p => {
						const [testLocation] = testLocationState
						return p.id === testLocation
					})!}
					typeState={typeState}
					version={versionState[0]!}
				/>

			case Step.SelectChueiBankTestCourse:
				return !testPlaces ? <Loading /> :  <SelectChueiBankTestCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)}/>

			case Step.SelectRiebeTestCourse:
				return !testPlaces ? <Loading /> :  <SelectRiebeTestCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)}/>

			case Step.SelectKyofukuTestCourse:
				return !testPlaces ? <Loading /> :  <SelectKyofukuTestCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)} kyofukuType={kyofukuMemberTypeState[0]}/>

			case Step.SelectPromotionTestCourse:
				return !testPlaces ? <Loading /> :  <SelectPromotionTestCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)}/>

			case Step.SelectSapporoTestCourse:
				return !testPlaces ? <Loading /> :  <SelectSapporoChushoTestCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)}/>

			case Step.SelectBohseiTestCourse:
				return !testPlaces ? <Loading /> :  <SelectBohseiTestCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)}/>

			case Step.SelectGenovisionTestCourse:
				return !testPlaces ? <Loading /> :  <SelectGenovisionTestCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)} genovisionType={Number(genovisionTypeState[0])}/>
			
			case Step.SelectInsuranceTestCourse:
				return !testPlaces ? <Loading /> :  <SelectInsuranceTestCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)}/>
			
			case Step.SelectReloClubTestCourse:
				return !testPlaces ? <Loading /> :  <SelectReloClubTestCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)}/>
			
			case Step.SelectBenefitTestCourse:
				return !testPlaces ? <Loading /> :  <SelectBenefitTestCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)}/>
			
			case Step.SelectCouponCodeTestCourse:
				return !testPlaces ? <Loading /> :  <SelectCouponCodeCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)} couponCode={couponCodeState[0]!}/>
			
			case Step.SelectGoldenLoopTestCourse:
				return !testPlaces ? <Loading /> :  <SelectGoldenLoopCourse onPrev={prev} onNext={next} antiCovid19TestState={antiCovid19TestState} testPlace={testPlaces.find(p => {
					const [testLocation] = testLocationState
					return p.id === testLocation
				})!} testCourseState={testCourseState} typeState={typeState} version={getVersion(testDates?.find(p => p.id === testDateState[0])?.startDate)}/>

			case Step.InputPersonalInformation:
				return !testPlaces ? <Loading /> : <InputPersonalInformation
					onNext={next} onPrev={prev}
					zipcodeState={zipcodeState}
					address1State={address1State}
					address2State={address2State}
					phoneNumberState={phoneNumberState}
					confirmMailAddressState={confirmMailAddressState}
					mailAddressState={mailAddressState}
					firstNameState={firstNameState}
					firstNameKanaState={firstNameKanaState}
					lastNameState={lastNameState}
					lastNameKanaState={lastNameKanaState}
					sexState={sexState}
					birthYearState={birthYearState}
					birthMonthState={birthMonthState}
					birthDateState={birthDateState}
					birthdayState={birthdayState}
					introducerIdState={introducerIdState}
					addresses={addresses}
					howDidYouKnowState={howDidYouKnowState}
					howDidYouKnowAdMediaState={howDidYouKnowAdMediaState} 
					testTypeState={testTypeState}
					hasEntryBeforeState={hasEntryBeforeState}
					/>

			case Step.Confirm:
				return !testPlaces ? <Loading /> : <Confirm
					onNext={next} onPrev={prev}
					// test data
					testTypeState={testTypeState}
					testCourseState={testCourseState}
					testLocationState={testLocationState}

					// kyofuku member information
					kyofukuMemberTypeState={kyofukuMemberTypeState}
					kyofukuMemberIdState={kyofukuMemberIdState}
					kyofukuMemberNameState={kyofukuMemberNameState}

					// Chuei member information
					chueiBankMemberTypeState={chueiBankMemberTypeState}

					// MB Club information
					mbClubPaymentMethodState={mbClubPaymentMethodState}
					mbClubMemberIdState={mbClubMemberIdState}
					lastTestLocationState={lastTestLocationState}
					lastTestDateState={lastTestDateState}

					//personal information
					zipcodeState={zipcodeState}
					address1State={address1State}
					address2State={address2State}
					phoneNumberState={phoneNumberState}
					mailAddressState={mailAddressState}
					firstNameState={firstNameState}
					firstNameKanaState={firstNameKanaState}
					lastNameState={lastNameState}
					lastNameKanaState={lastNameKanaState}
					sexState={sexState}
					introducerIdState={introducerIdState}
					antiCovid19TestState={antiCovid19TestState}

					birthdayState={birthdayState}
					// fetched data
					testLocation={testPlaces.find(p => {
						const [testLocation] = testLocationState
						return p.id === testLocation
					})}
					testDate={testDates?.find(d => {
						const [testDate] = testDateState
						return d.id === testDate
					})}
					lastTestLocation={testPlaces.find(p => {
						const [lastTestLocation] = lastTestLocationState
						return p.id === lastTestLocation
					})}
					messageState={messageState}
					hasEntryBeforeState={hasEntryBeforeState}
					howDidYouKnowState={howDidYouKnowState}
					howDidYouKnowAdMediaState={howDidYouKnowAdMediaState}
					typeState={typeState}
					/>

			case Step.Sending:
				return <Sending/>

			case Step.Complete:
				return !testPlaces ? <Loading /> : <Complete res={postRes!} testPlaces={testPlaces}/>

			case Step.Failed:
				return <Failed />
			
			default:
				assertUnreachable(step)
		}
	}
	return <>
		{
			[Step.Complete, Step.Confirm, Step.Failed].includes(step) ||
			<SelectedItems>
				{
					step !== Step.SelectTestType && testTypeState[0] !== null && <div>申し込み区分:{OLD_TEST_TYPE_LABEL[testTypeState[0]]}</div>
				}
				{
					testLocationState[0] !== null && <div>検査会場:{testPlaces?.find(p => p.id === testLocationState[0])?.name}</div>
				}
				{
					testDateState[0] !== null && <div>検査日程:{dayjs(testDates?.find(p => p.id === testDateState[0])?.startDate).tz('Asia/Tokyo').format('YYYY年MM月DD日(ddd) HH:mm')} - {dayjs(testDates?.find(p => p.id === testDateState[0])?.endDate).tz('Asia/Tokyo').format('HH:mm')}</div>
				}
				{
					testCourseState[0] !== null && <div>検査コース:{OLD_TEST_COURSE_LABEL[testCourseState[0]]}</div>
				}
				{
					typeState[0] !== null && <div>検査項目:{typeLabel[typeState[0]]}</div>
				}
			</SelectedItems>
		}
		{getStepContent()}
	</>
}

function Loading(){
	return <>
		読み込み中...
	</>
}

function Sending(){
	return <>
		送信中
	</>
}

function Failed(){
	return <>
		<p className="entry-form-text">送信に失敗しました。しばらくしてからもう一度お試しいただくか、<br /><a href="https://www.microsoft.com/ja-jp/edge">Microsoft Edge</a>・<a href="https://www.google.com/intl/ja_jp/chrome/">Google Chrome</a>などの最新のブラウザをご利用ください。</p>
	</>
}
